module.exports = __webpack_public_path__ + "img/monitorbox13.e2d4791e.jpg";